import React from 'react';
import './../App.css';

const Main = () => {
  return (
    <div className="main-content">
      <img className="contact-form card" src="/contact.jpg" alt="Contact us" />
    </div>
  );
};

export default Main;